module.exports = __webpack_public_path__ + "img/appDownloadMask.9aa0a7ed.png";